import React, { Fragment } from 'react'
import { Icon, Avatar, Thumb, Header } from '../'
import './list.css'

/**
 * List
 */
const List = ({ icon, title, items = [], actions=[], children, group, selected, onSelect, onEmpty, className }) => {

  const sections = group ? items.reduce((groups, item) => {
    const name = item[group.by]
    let agroup = groups.find(group => group.name === name)
    if (!agroup) {
      agroup = { icon: group.icon, name, items: [], toolbar: group.toolbar, footer: group.footer, onSelect }
      groups.push(agroup)
    }
    item.selected = item.id === selected
    agroup.items.push(item)
    return groups
  }, []) : [{ items, onSelect }]

  const empty = onEmpty ? onEmpty() : <div>...</div>

  return (
    <div className={`list-box ${className}`}>
      {title || icon ? <Header icon={{ icon }} title={title} className="list-title">{actions}</Header> : '' }
      <div className="list">
        { items.length === 0 ? empty : sections.map(group => <ListGroup {...group} >{children}</ListGroup>) }
      </div>
    </div>
  )
}

/**
 * List Group
 */
const ListGroup = ({ icon, name = "", items, toolbar, footer, children, onSelect }) => {

  const renderItem = (item) => {
    return children ? React.Children.map(children, child => React.cloneElement(child, item)) : <ListItem {...item} />
  }

  return (
    <Fragment>
      {name ? (
        <Header icon={icon} title={name} className="group-item" >
          {toolbar ? toolbar({ name, items }) : ''}
        </Header>
      ) : ''}
      {items.map(item => <ListItemBox {...item} onSelect={onSelect}>{renderItem(item)}</ListItemBox>)}
      {footer ? <footer className="group-footer">{footer({ name, items })}</footer> : ''}
    </Fragment>
  )
}

/**
 * List Item Box
 */
const ListItemBox = ({ id, selected = false, onSelect, children }) => {

  const select = () => {
    if (onSelect) onSelect(id)
  }

  const style = selected ? 'selected' : ''

  return (
    <div key={`list-item-${id}`} className={`list-item-box ${style}`} onClick={select}>
      {children}
    </div>
  )
}

/**
 * ListItem
 */
const ListItem = ({ id, check = null, icon, avatar, thumb, overline, title, text, meta, actions, onCheck, onSelect, className}) => {
  return (
    <div key={id} className={`list-item ${className}`}>
      {check !== null ? <Icon icon={ check === true ? 'check_box' : 'check_box_outline_blank' } small action={() => {onCheck(id)}}/> : ''}
      {icon ? <Icon icon={icon} /> : ''}
      {avatar ? <Avatar src={avatar.src} name={avatar.name} /> : ''}
      {thumb ? <Thumb src={thumb} /> : ''}
      <main onClick={onSelect}>
        { overline ? <span className="overline secondary">{overline}</span> : '' }
        <span className="subtitle1 primary">{title}</span>
        { text ? <span className="caption secondary">{text}</span> : '' }
      </main>
      {meta ? <div className="meta">{meta}</div> : ''}
      <aside>
        {actions}
      </aside>
    </div>
  )
}

export { List, ListItem }



// WEBPACK FOOTER //
// ./src/lib/components/list.js